"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fork = fork;
exports.increment = increment;
exports.merge = merge;
exports.push = push;
exports.initArray = initArray;

var _get = _interopRequireDefault(require("lodash/get"));

var _immer = _interopRequireDefault(require("immer"));

var _merge = _interopRequireDefault(require("lodash/merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function fork(callback) {
  callback();
}

function increment(object, path) {
  var number = (0, _get.default)(object, path);

  if (number == null) {
    return 1;
  }

  return number + 1;
}

function merge(object) {
  for (var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    objects[_key - 1] = arguments[_key];
  }

  return (0, _immer.default)(object, function (draft) {
    _merge.default.apply(void 0, [draft].concat(objects));
  });
}

function push(array, item) {
  if (Array.isArray(array)) {
    return [].concat(_toConsumableArray(array), [item]);
  }

  return [item];
}

function initArray(object, path) {
  var value = (0, _get.default)(object, path);

  if (Array.isArray(value)) {
    return value;
  }

  return [];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-plugin/lib/utils.js
// module id = 587
// module chunks = 0